<style>
    .no-found {
        color: #48576a;
        text-align: center;
    }
</style>
<template>
    <div class="no-found">
        <img src="../assets/img/404.png" alt="">    
        <p>你可能迷路了，将在 {{time}} 秒后 <a href="#/" class="el-button el-button--text" title="返回首页">返回首页</a></p>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                time: 5
            }
        },
        mounted () {
            let inter = setInterval(() => {
                this.time--
                if (this.time <= 0) {
                    clearInterval(inter)
                    this.$router.push('/')
                }
            }, 1000)
        }
    }
</script>